import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { SearchPage } from "./search/SearchPage";
import { PreApprovalWorkspaceLayout } from "./workspace/PreApprovalWorkspaceLayout";
import { ConditionsPanel } from "./workspace/conditions/ConditionsPanel";
import { NotesPanel } from "./workspace/notes/NotesPanel";
import { ActivityHistoryPanel } from "./workspace/history/ActivityHistoryPanel";

export default function PreApprovalApp() {
  return (
    <Routes>
      <Route index element={<SearchPage />} />
      <Route path=":applicationId" element={<PreApprovalWorkspaceLayout />}>
        <Route index element={<Navigate to="conditions/customer" replace />} />
        <Route
          path="conditions/customer"
          element={<ConditionsPanel section="customer" />}
        />
        <Route
          path="conditions/funding"
          element={<ConditionsPanel section="funding" />}
        />
        <Route
          path="conditions/seller"
          element={<ConditionsPanel section="seller" />}
        />
        <Route path="notes" element={<NotesPanel />} />
        <Route path="history" element={<ActivityHistoryPanel />} />
      </Route>
    </Routes>
  );
}
